let tableData = [];
const bindSwatches = () => {
  $("#colorSwatches").empty();
  colorSwatches.forEach(function (swatch, i) {
    $("#colorSwatches").append(`
                <div
                data-color="${swatch.color}"
                data-tone="${swatch.tone}"
                data-material="${swatch.material}"
                class="toHide col-sm-3 position-relative"
                onmouseover="showImage(event,'${i}')"
                onmouseleave="hideImage(${i})"          
                >
                <div class="form-group">
                    <input
                    image="${swatch.image}"
                    name="${swatch.imageName}"
                            
                    id="${i + 1}"
                    type="checkbox"
                    class="checkBoxADD check${i + 1}"
                    />
                    <label>
                    <img width="100" height="100" src="${swatch.image}" />
                    </label>
                </div>
                <span>${swatch.imageName}</span>
                <div id="expandedImg-${i}" 
                class="position-absolute hover-container">
                <div id="carousel-${i}" class="carousel slide w-100 h-100 rounded-full" data-bs-ride="true">
                    <div class="carousel-inner" >
                    ${
                      swatch?.carasouel
                        ?.map(
                          (img, i) =>
                            `<div class="carousel-item ${i == 0 && "active"}">
                                <img
                                src="${img}"
                                style="height: 100%"
                                alt="..."
                                />
                            </div>`
                        )
                        .join("") ||
                      `<div class="carousel-item active">
                        <img
                          src="${swatch.image}"
                          alt="..."
                          style="height: 100%"
                        />
                      </div>`
                    }
                    </div>
                    <button
                        class="carousel-control-prev"
                        type="button"
                        data-bs-target="#carousel-${i}"
                        data-bs-slide="prev"
                    >
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                        class="carousel-control-next"
                        type="button"
                        data-bs-target="#carousel-${i}"
                        data-bs-slide="next"
                    >
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                    </button>
                    </div>
                </div>
                </div>

            `);
  });
};

const hideImage = (imgId) => {
  const id = "#expandedImg-" + imgId;
  $(id).css("display", "none");
};

const showImage = (event, imgUrl) => {
  const targetElement = $(event.target);
  const id = "#expandedImg-" + imgUrl;
  $(id).css("display", "flex");
};

$(document).ready(function () {
  var errorMessage = "Please enter a valid email address.";
  $.validator.addMethod(
    "regex",
    function (value, element, regexp) {
      if (regexp && regexp.constructor != RegExp) {
        regexp = new RegExp(regexp);
      } else if (regexp.global) regexp.lastIndex = 0;
      return this.optional(element) || regexp.test(value);
    },
    errorMessage
  );

  $("#detail-form").validate({
    rules: {
      first_name: "required",
      last_name: "required",
      email: {
        required: true,
        email: true,
        regex: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
      },
      address: "required",
      //address2: "required",
      postcode: "required",
      town: "required",
      phone: {
        required: true,
        digits: true,
        minlength: 1,
        maxlength: 15,
      },
    },
    messages: {
      title: {
        required: "Please Select Your title",
      },
      first_name: {
        required: "Please enter first name",
      },
      last_name: {
        required: "Please enter last name",
      },
      address: {
        required: "Please enter address1",
      },
      // address2: {
      //   required: "Please enter address2",
      // },
      postcode: {
        required: "Please enter postcode",
      },
      phone: {
        required: "Please enter contact number",
        digits: "Please enter valid phone number",
        minlength: "Phone number field accept minimum 1 digits",
        maxlength: "Phone number field accept maximum 15 digits",
      },
      email: {
        required: "Please enter email address",
        email: "Please enter a valid email address.",
      },
      town: {
        required: "Please enter Town/City ",
      },
    },
    submitHandler: function (form) {
      if ($("#swatchesValue").val() == "") {
        alert("select at least one Swatch*");
        $("html, body").animate({
          scrollTop:
            $(".row.addHere").offset().top -
            ($("#shopify-section-text-columns-with-images-c").height() +
              $("#shopify-section-header").height()),
        });
        return false;
      } else if ($("#detail-form label.error").text() !== "") {
        return false;
      } else {
        $("#loading-container").css("display", "flex");
        const formData = new FormData(form);
        const date = new Date();
        const formDataObject = {};
        for (const [key, value] of formData.entries()) {
          formDataObject[key] = value;
        }
        // console.log({...formDataObject,date:date.toLocaleString()})
        addDocument({...formDataObject,date:date.toLocaleString()})
          .then(() => {
            $("#loading-container").css("display", "none");
            
            window.location.replace("https://sleepvillage.co.uk/pages/page");
          })
          .catch(() => $("#loading-container").css("display", "none"));
      }
    },
  });
});

$(window).on("scroll", function () {
  if (
    $(window).scrollTop() >=
    $(".scroll-main-div").offset()?.top +
      $(".scroll-main-div").outerHeight() -
      window.innerHeight
  ) {
    $(".addAddedSwatchHere").removeClass("sticky-div", 1000);
  } else {
    $(".addAddedSwatchHere").addClass("sticky-div", 1000);
  }
});

let addSwatch = [];

$(document).on("click", ".checkBoxADD", function () {
  if ($(".checkBoxADD:checked").length >= 7) {
    $(this).prop("checked", false);
    $("#colorSwatches").css("opacity", ".6");
    $(".checkBoxADD").prop("disabled", true);
    return false;
  }

  $("#colorSwatches").css("opacity", "1");
  let name = $(this).attr("name");

  if ($(this).is(":checked")) {
    addSwatch.push(name);
    let image = $(this).attr("image"),
      id = $(this).attr("id");
    $(".addAddedSwatchHere").append(
      `<div class="col-sm-3" style="background-color:lavender;">
         <div class="form-group cross">
           <input checked image="${image}" name="${name}" id="${id}" type="checkbox" class="checkBoxremove remove${id}">
           <img width="100" height="100" src="${image}">
           <span data-id="${id}" class="swatches__span checkBoxremove remove${id}"></span>
         </div>
         <span>${name}</span>
       </div>`
    );
  } else {
    addSwatch = addSwatch.filter((item) => item !== name);
    $(`.remove${$(this).attr("id")}`)
      .parent()
      .parent()
      .remove();
  }

  $("#swatchesValue").val(addSwatch);
});

$(document).on("click", ".checkBoxremove", function () {
  $(".addHere_color").css("opacity", "1");
  $(".checkBoxADD").prop("disabled", false);
  $(`#${$(this).data("id")}`).trigger("click");
  addSwatch = addSwatch.filter((item) => item !== $(this).attr("name"));
  $("#swatchesValue").val(addSwatch);
});


var filterAarry = [];
$(document).on("change", ".colorChange", function () {
  $(".toHide").hide();
  if ($(this).is(":checked")) {
    filterAarry.push($(this).attr("data-type"));
  } else {
    var index = filterAarry.indexOf($(this).attr("data-type"));
    if (index !== -1) {
      filterAarry.splice(index, 1);
    }
  }
  checkSwatches(filterAarry, toneAarry, materialArray);
});

var toneAarry = [];
$(document).on("change", ".toneChange", function () {
  $(".toHide").hide();
  if ($(this).is(":checked")) {
    toneAarry.push($(this).attr("data-type"));
  } else {
    var index = toneAarry.indexOf($(this).attr("data-type"));
    if (index !== -1) {
      toneAarry.splice(index, 1);
    }
  }
  checkSwatches(filterAarry, toneAarry, materialArray);
});

var materialArray = [];
$(document).on("change", ".materialChange", function () {
  $(".toHide").hide();
  if ($(this).is(":checked")) {
    materialArray.push($(this).attr("data-type"));
  } else {
    var index = materialArray.indexOf($(this).attr("data-type"));
    if (index !== -1) {
      materialArray.splice(index, 1);
    }
  }
  checkSwatches(filterAarry, toneAarry, materialArray);
});

function checkSwatches(filterAarry, toneAarry, materialArray) {
  $(".toHide").each(function () {
    var color = $(this).attr("data-color");
    var tone = $(this).attr("data-tone");
    var material = $(this).attr("data-material");

    var colorMatch = 0;
    var toneMatch = 0;
    var materialMatch = 0;
    if (filterAarry.length > 0) {
      for (var i = 0; i < filterAarry.length; i++) {
        if (color == filterAarry[i]) {
          colorMatch = 1;
        }
      }
    } else {
      colorMatch = 1;
    }

    if (toneAarry.length > 0) {
      for (var i = 0; i < toneAarry.length; i++) {
        if (tone == toneAarry[i]) {
          toneMatch = 1;
        }
      }
    } else {
      toneMatch = 1;
    }
    if (materialArray.length > 0) {
      for (var i = 0; i < materialArray.length; i++) {
        if (material == materialArray[i]) {
          materialMatch = 1;
        }
      }
    } else {
      materialMatch = 1;
    }
    if (colorMatch == 1 && toneMatch == 1 && materialMatch == 1) {
      $(this).show();
    }
  });
}

$(document).on("click", ".clear-filter", function () {
  $(".colorChange").prop("checked", false);
  $(".toneChange").prop("checked", false);
  $(".materialChange").prop("checked", false);

  $(".colorChange").trigger("change");
  $(".toneChange").trigger("change");
  $(".materialChange").trigger("change");
  filterAarry = [];
  toneAarry = [];
  materialArray = [];
  bindSwatches();
});

$(window).on("load", function () {
  emailjs.init("qbqAZeDLKB_GQU_yq");
  bindSwatches();
});
